// load google map

//import icon from '../../../../assets/google-pin.png';

let map;
let styles = [
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }
];

function initMap() {
  const mapHolder = document.querySelector('.google-map__inner');
  const locations = window.locations;
  
  if (mapHolder !== null) {
    const zoomLevel = document.querySelector('.js-google-map').dataset.zoomLevel;
    var bounds = new google.maps.LatLngBounds();

    map = new google.maps.Map(document.querySelector(".js-google-map"), {
        center: { lat: 59.1508351, lng: 9.5997069 }, 
        zoom: zoomLevel == null ? parseInt(zoomLevel) : 9,
        styles: styles,
        mapTypeControl: false,
    });

    google.maps.event.addListener(map, 'tilesloaded', function() {
        var images = document.querySelectorAll('.google-map img');
        images.forEach(function(image) {
          image.alt = ""; // decorative only, just adding an empty alt.
        });
      });

    if (location != null) {
        locations.forEach((marker) => {
            marker.coords.lat = parseFloat(marker.coords.lat);
            marker.coords.lng = parseFloat(marker.coords.lng);
            
            let content = marker.content;
            content = "<div class='google-map-contentbox'>" + content + "</div>";
            const icon = (marker.type == "service") 
                ? '/assets/images/map/map-marker-office.svg' 
                : '/assets/images/map/map-marker-person.svg';
            const m = new google.maps.Marker({
                position: marker.coords,
                map: map,
                icon: {
                    url: icon,
                    size: new google.maps.Size(35, 35),
                    scaledSize: new google.maps.Size(35, 35),
                    origin: new google.maps.Point(0,0)
                },
            });
           
            const infowindow = new google.maps.InfoWindow({
                content: content,
            });

            bounds.extend(m.position);

            m.addListener("click", () => {
               infowindow.open(mapHolder, m);
            });
          
        })
    }
    map.fitBounds(bounds);
    }

    // var zoomChangeBoundsListener = 
    // google.maps.event.addListenerOnce(map, 'bounds_changed', function(event) {
    //     if (this.getZoom() && locations.length == 1){
    //         this.setZoom(11);
    //     }
    // });

    // setTimeout(function(){google.maps.event.removeListener(zoomChangeBoundsListener)}, 2000);
            
    //         m.addListener("click", () => {
    //             infowindow.open(mapHolder, m);
    //         });
    //     })
    // }
}

window.initMap = initMap;